module.exports = __webpack_public_path__ + "static/3-1d1a91e4690a13cd83f4140fc8b2afee.png";